
import { Vue, Component, Prop } from "vue-property-decorator";
import Package from "@/models/Subscriptions/SubscriptionPackages/Package";
import { mapState } from "vuex";
import { SubscriptionRecurrenceType } from "@/models/Subscriptions/SubscriptionRecurrenceType";
import { SubscriptionStatus } from "../models/Subscriptions/SubscriptionStatus";
import { SubscriptionMigrationTypeEnum } from "../models/Subscriptions/SubscriptionPackages/SubscriptionMigrationTypeEnum";

@Component({
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class vPackageCard extends Vue {
  localizationState: any;

  @Prop() item!: Package;
  @Prop() subscriptionRecurrenceType!: SubscriptionRecurrenceType;
  @Prop() changeButton?: boolean;
  @Prop() activeSubscription?: Package;
  @Prop() compareCard?: boolean;

  trial = true;
  subscriptionMigrationTypeEnum = SubscriptionMigrationTypeEnum;
  subscriptionRecurrenceTypeEnum = SubscriptionRecurrenceType;

  chooseSubscription(id: number) {
    this.$emit("choose", id);
  }

  chooseTrial() {
    this.$emit("trial", this.trial);
  }

  changeSubscription() {
    this.$emit("changeSubscription");
  }

  get monthlyPriceFromYearly() {
    return Math.round(this.item.price / 12);
  }

  /**
   * Returns true if the package means upgrade
   *
   * @returns {boolean}
   */
  get shouldShowSubscribeButton() {
    return (
      this.$store.getters.getUserDetails.isTrial ||
      this.$store.getters.getUserDetails.subscriptionStatus ===
      SubscriptionStatus.Expired
    );
  }

  /**
   * Return the text for the subscribe button
   */
  get subscriptionMigrationType() {
    if (this.item.isEnterprise) {
      return this.translations.get("ms_enterprise_subscription");
    }
    else if (
      this.item.subscriptionMigration &&
      this.item.subscriptionMigration.subscriptionMigrationType ===
      SubscriptionMigrationTypeEnum.Upgrade
    ) {
      return this.translations.get("ms_upgrade");
    }
    else if (
      this.item.subscriptionMigration &&
      this.item.subscriptionMigration.subscriptionMigrationType ===
      SubscriptionMigrationTypeEnum.Downgrade
    ) {
      return this.translations.get("ms_downgrade");
    }
    else if (
      this.item.subscriptionMigration &&
      this.item.subscriptionMigration.subscriptionMigrationType ===
      SubscriptionMigrationTypeEnum.Current
    ) {
      return this.translations.get("ms_current_subscription");
    }
    else {
      return "";
    }
  }

  /**
   * Returns true if has active process for payment in Braintree
   *
   * @returns {boolean}
   */
  get hasDraftSubscription() {
    return this.$store.getters.getUserDetails.hasDraftSubscription;
  }

  /**
   * Highlighting the current subscription, user has
   */
  get shouldShowCurrentSubscription() {
    return (
      this.activeSubscription !== undefined &&
      this.item.id === this.activeSubscription.id &&
      this.subscriptionRecurrenceType ===
      this.$store.getters.getUserDetails.subscriptionRecurrenceType
    );
  }

  get shouldShowEnterpriseSubscription() {
    return this.item.isEnterprise;
  }

  get translations() {
    return this.localizationState.translations;
  }
}
